import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function downloadReport(leadId, reportType) {
  if (!leadId) {
    alert("Report not available for this opportunity.");
    return;
  }
  const token = localStorage.getItem("ic_token");
  if (!token) throw new Error("Not authenticated");

  const endpointMap = {
    summary: "deal-summary",
    underwriting: "underwriting",
    "deal-packet": "deal-packet",
    "deal-deck": "deal-deck",
  };
  const endpoint = endpointMap[reportType] || reportType;

  try {
    // Deal deck returns a URL (uploaded file), others return PDF blobs
    if (reportType === "deal-deck") {
      const res = await axios.get(`${API}/reports/${endpoint}/${leadId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const fileUrl = res.data.url;
      if (fileUrl) {
        const a = document.createElement("a");
        a.href = fileUrl;
        a.target = "_blank";
        a.download = res.data.filename || "deal_deck.pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
      return;
    }

    const res = await axios.get(`${API}/reports/${endpoint}/${leadId}`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    });

    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${endpoint}_${leadId}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    const msg = err.response?.status === 403
      ? "You must commit to this deal before accessing reports."
      : err.response?.status === 404
        ? reportType === "deal-deck"
          ? "No deal deck has been uploaded for this deal yet."
          : "Report not found for this deal."
        : "Failed to download report. Please try again.";
    alert(msg);
  }
}
